import { useQuery } from '@apollo/client';
import { toast } from '@chakra-ui/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setImages } from '../../redux/imagesSlice';
import { setMockImages } from '../../redux/mockImagesSlice';
import query from '../../utils/query';

const ImagesImport = ({ viewId }) => {
	const imagesQueries = useQuery(query.GET_VIEW_IMAGES(viewId));
	const imagesMockQueries = useQuery(query.GET_MOCK_VIEW_IMAGES(viewId));
	const dispatch = useDispatch();

	React.useEffect(() => {
		if (imagesQueries.data?.getViewImages?.images) {
			dispatch(setImages(JSON.parse(imagesQueries.data?.getViewImages?.images)));
		}
	}, [imagesQueries.data]);

	React.useEffect(() => {
		if (imagesMockQueries.data?.getMockViewImages?.mockImages) {
			const mock = JSON.parse(imagesMockQueries.data?.getMockViewImages?.mockImages);
			if (!mock?.product && !mock?.shelf) return;
			dispatch(setMockImages(mock));
		}
	}, [imagesMockQueries.data]);

	React.useEffect(() => {
		if (imagesQueries.error || imagesMockQueries.error) {
			toast(errorMessage);
		}
	}, [imagesQueries.error, imagesMockQueries.error]);

	return null;
};

export default ImagesImport;

const errorMessage = {
	title: 'Ocorreu um erro ao tentar recuperar as imagens',
	status: 'error',
	duration: '4000',
	isClosable: true,
};
